import gql from 'graphql-tag';
export const GET_USER_PERMISSIONS = gql `
  query User($id: UUID!, $appIds: [String!]) {
    user(id: $id) {
      id
      permissions(groupIds: $appIds) {
        group
        roles
      }
    }
  }
`;
//# sourceMappingURL=getUserPermissions.js.map